<div class="movement-actions">
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    type="button"
    mat-raised-button
    (click)="addMovementHandler()">
    {{ 'Aggiungi movimento' | translate }}
  </button>
</div>
<div [formGroup]="form">
  <ui-draggable-list
    *ngIf="movements.length > 0; else noItems"
    [items]="movements"
    (dropComplete)="orderMovementHandler($event)">
    <ng-template
      uiListItem
      let-movement="item"
      let-i="index">
      <div class="movement-container">
        <div
          class="movement-actions"
          *roleVisibility="['create', 'update']; classNames: classNames">
          <button
            mat-icon-button
            type="button"
            (click)="removeMovementHandler(i)">
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            (click)="editMovementHandler(movement, i)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div
          class="movement-info-container"
          [formArrayName]="i">
          <div>
            <small class="movement-info">
              {{ 'Descrizione' | translate }}: {{ movement?.descrizione  }}
            </small>
            <small class="movement-info">
              {{ 'Scope' | translate }}: {{ movement?.scopo }}
            </small>
            <small class="movement-info">
              {{ 'Data Uscita' | translate }}: {{ movement?.dataUscita | date : 'dd/MM/yyyy' }}
            </small>
            <small class="movement-info">
              {{ 'Data Rientro' | translate }}: {{ movement?.dataRientro | date: 'dd/MM/yyyy' }}
            </small>
            <small class="movement-info">
              {{ 'Allegati presenti' | translate }}: {{ movement?.allegati?.length }}
            </small>
          </div>
        </div>
      </div>
    </ng-template>
  </ui-draggable-list>

  <ng-template #noItems>
    <ui-no-items [size]="40"></ui-no-items>
  </ng-template>
</div>
